import { faLock, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mixpanel from "mixpanel-browser";
import React from "react";

import { handleSubscribe } from "../../../api/Billing";
import { UNLIMITED_PRICE_ID_MONTHLY } from "../../../constants";
import { BasicButton } from "../../common/buttons/BasicButton";

export default function TemplatesFreePlanState() {
  const handleUpgrade = () => {
    handleSubscribe({
      priceId: UNLIMITED_PRICE_ID_MONTHLY,
      route: "/templates",
    });
    mixpanel.track("Upgrade Plan Clicked", {
      featureName: "Adaptive Templates",
    });
  };

  return (
    <div
      className="flex flex-col items-center justify-center max-w-3xl mx-auto py-12 px-4"
      data-testid="templates-free-plan-state"
    >
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center bg-indigo-100 dark:bg-indigo-900/50 rounded-full p-2 mb-4">
          <FontAwesomeIcon
            icon={faLock}
            className="text-indigo-600 dark:text-indigo-400"
            size="lg"
          />
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-3">
          Unlock Adaptive Templates
        </h2>
        <p className="text-gray-600 dark:text-gray-300 text-lg max-w-xl mx-auto">
          Create custom templates that adapt to the way you write
          notes and let Scribenote <i>Scribe Like You</i>. Watch to
          learn how you can use Adaptive Templates to save even more
          time on your notes:
        </p>
      </div>

      <div className="w-full max-w-2xl aspect-video rounded-xl overflow-hidden shadow-lg bg-gray-900">
        <iframe
          src="https://www.youtube.com/embed/YQeVKqZXBHk"
          title="Scribenote Templates Demo"
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      <div className="mt-10 text-center">
        <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-4">
          What you'll get with Adaptive Templates:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-xl mx-auto text-left">
          <div className="flex items-start space-x-3 p-3 rounded-lg bg-white dark:bg-gray-800 shadow-sm">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
              <FontAwesomeIcon
                icon={faCheck}
                className="text-green-600 dark:text-green-400 text-xs"
              />
            </div>
            <span className="text-gray-700 dark:text-gray-300">
              Upload an existing template PDF for an easy transition
            </span>
          </div>
          <div className="flex items-start space-x-3 p-3 rounded-lg bg-white dark:bg-gray-800 shadow-sm">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
              <FontAwesomeIcon
                icon={faCheck}
                className="text-green-600 dark:text-green-400 text-xs"
              />
            </div>
            <span className="text-gray-700 dark:text-gray-300">
              Favorite templates for quick access
            </span>
          </div>
          <div className="flex items-start space-x-3 p-3 rounded-lg bg-white dark:bg-gray-800 shadow-sm">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
              <FontAwesomeIcon
                icon={faCheck}
                className="text-green-600 dark:text-green-400 text-xs"
              />
            </div>
            <span className="text-gray-700 dark:text-gray-300">
              Share templates with your team
            </span>
          </div>
          <div className="flex items-start space-x-3 p-3 rounded-lg bg-white dark:bg-gray-800 shadow-sm">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
              <FontAwesomeIcon
                icon={faCheck}
                className="text-green-600 dark:text-green-400 text-xs"
              />
            </div>
            <span className="text-gray-700 dark:text-gray-300">
              Use Scribenote's templates as a starting point
            </span>
          </div>
        </div>
      </div>

      <BasicButton
        onClick={handleUpgrade}
        importance="primary"
        styles="mt-10"
      >
        <div className="flex items-center space-x-2">
          <span>Get Access to Adaptive Templates</span>
          <FontAwesomeIcon icon={faLock} size="sm" />
        </div>
      </BasicButton>
    </div>
  );
}
